import { ReactNode } from 'react';
import Layout from '../layout/Layout';

type EmbeddedLayoutProps = {
    children: ReactNode;
    embedded?: boolean;
    title: string;
};

export default function EmbeddedLayout({ children, embedded = false, title }: EmbeddedLayoutProps) {
    if (embedded) return <>{children}</>;
    return <Layout title={title}>{children}</Layout>;
}
